import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
const before = ['Horas planificando cada clase', 'Actividades repetitivas', 'Sin conexión con la historia del arte', 'No saber cómo evaluar correctamente', 'Alumnos desmotivados'];
const after = ['5 minutos de repaso y listo', 'Proyectos variados y creativos', 'Movimientos artísticos integrados', 'Rúbricas y evaluaciones listas', 'Alumnos que se expresan con libertad'];
const highlights = [['+300', 'Actividades'], ['12', 'Tomos'], ['100%', 'Descargable']];
export function TransformationSection() {
  return <section className="bg-brand-cream px-4 py-20 sm:py-24" data-id="element-177" data-mp="298bbrkre4gsr">
      <Reveal className="mx-auto max-w-5xl" data-id="element-178" data-mp="299w5j85vrvpk">
        <SectionHeading eyebrow="La transformación" title={<>
              De un docente sobrecargado a un{' '}
              <span className="italic text-brand-terra" data-id="element-180" data-mp="2086fa5nqj2td">guía inspirado.</span>
            </>} subtitle="3.500+ horas ahorradas al año en planificación." data-id="element-179" data-mp="249hy9sc3spsl" />

        <div className="mt-14 grid gap-5 md:grid-cols-2" data-id="element-181" data-mp="k2kk9uao5tym">
          <Column title="Antes" items={before} positive={false} data-id="element-182" data-mp="5d6banb09ejr" />
          <Column title="Con Arte Lista" items={after} positive data-id="element-183" data-mp="5atjzjjcxru1" />
        </div>

        <div className="mx-auto mt-10 grid max-w-3xl divide-y divide-brand-line overflow-hidden rounded-2xl border border-brand-line bg-brand-alt sm:grid-cols-3 sm:divide-x sm:divide-y-0" data-id="element-184" data-mp="aciumy2o43hl">
          {highlights.map(([value, label]) => <div key={label} className="px-6 py-6 text-center" data-id="element-185" data-mp="p0vtq3x1y2gb">
              <strong className="block font-display text-2xl font-semibold leading-none text-brand-terra" data-id="element-186" data-mp="p0m2ye46nr9k">
                {value}
              </strong>
              <span className="mt-2 block text-[10px] font-semibold uppercase tracking-[0.14em] text-brand-gray" data-id="element-187" data-mp="39ql7sepxlk7y">
                {label}
              </span>
            </div>)}
        </div>
      </Reveal>
    </section>;
}
function Column({
  title,
  items,
  positive
}: {
  title: string;
  items: string[];
  positive: boolean;
}) {
  const Icon = positive ? CheckIcon : XIcon;
  return <div className={`rounded-3xl border p-7 sm:p-9 ${positive ? 'border-brand-terra/25 bg-brand-alt shadow-[0_10px_30px_rgba(23,32,60,0.06)]' : 'border-brand-line bg-brand-sand'}`} data-id="element-188" data-mp="1ajo2o1kb0462">
      <h3 className={`text-xs font-semibold uppercase tracking-[0.2em] ${positive ? 'text-brand-terra' : 'text-brand-gray'}`} data-id="element-189" data-mp="11l2la9qkiv6v">
        {title}
      </h3>
      <ul className="mt-6 space-y-4" data-id="element-190" data-mp="rm39wjef4lg6">
        {items.map(item => <li key={item} className="flex items-start gap-3.5" data-id="element-191" data-mp="mmqnu0vdfien">
            <span className={`mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full ${positive ? 'bg-brand-terra text-white' : 'bg-brand-gray/15 text-brand-gray'}`} data-id="element-192" data-mp="mobg1ju7qp9c">
              <Icon className="h-3 w-3" strokeWidth={3} aria-hidden="true" data-id="element-193" data-mp="2pgqvdb0nucez" />
            </span>
            <span className={`text-sm leading-snug sm:text-[15px] ${positive ? 'font-medium text-brand-text' : 'text-brand-gray line-through decoration-brand-gray/30'}`} data-id="element-194" data-mp="2thasiel8hg14">
              {item}
            </span>
          </li>)}
      </ul>
    </div>;
}